import React from 'react';
import PropTypes from 'prop-types';
import ChunkedUploadFolder from '../Shared/ChunkedUploadFolder';
import './NewSalesUploadFolder.css';

const NEW_SALES_ROOT = process.env.REACT_APP_NEW_SALES_BASE || '/new-sales';

function NewSalesUploadFolder({ currentPath, userId, onFolderUploaded }) {
  return (
    <ChunkedUploadFolder
      currentPath={currentPath}
      userId={userId}
      onFolderUploaded={onFolderUploaded}
      rootPath={NEW_SALES_ROOT}
      sessionPrefix="new_sales_folder"
    />
  );
}

NewSalesUploadFolder.propTypes = {
  currentPath: PropTypes.string,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onFolderUploaded: PropTypes.func,
};

export default NewSalesUploadFolder;
